import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { omit, keys, identity } from 'lodash/fp';

class Link extends Component {
  componentDidMount() {
    this.props.onMount(this.props);
  }

  static defaultProps = {
    onMount: identity,
    if: true,
  };

  render() {
    return (
      <NavLink
        className="LearnNavLink"
        activeClassName="CustomColor--borderColor DashboardSidebar-link--active"
        {...omit(keys(Link.defaultProps), this.props)}
      />
    );
  }
}

export default Link;
